import { apiBasedSubDomains } from "@/app/utils/constants";
import { getXPartner, isMTDomain } from "@/app/utils/helper";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const authHelpers = {
  otpAuthPostRequest,
  otpAuthGetRequest,
  waitlistAuthPostRequest
};

interface Headers {
  [key: string]: string;
}

interface Payload {
  [key: string]: any;
}

interface RequestOptions extends RequestInit {
  headers: Headers;
}

function createRequestOptions(method: 'GET' | 'POST', headers: Headers, payload?: Payload): RequestOptions {
    const partnerId = typeof window !== "undefined" ? sessionStorage.getItem("partnerId") : null;
    const partner = partnerId && String(partnerId)?.trim() != "" ? partnerId : "orowealth";
    const baseHeaders = {
        "Content-Type": "application/json",
        // "X-partner": partner,
        "X-partner": isMTDomain() ? getXPartner() : partner,
        ...headers,
    };

    const requestOptions: RequestOptions = {
        method,
        headers: baseHeaders,
        credentials: "include"
    };

    if (method === 'POST' && payload) {
        requestOptions.body = JSON.stringify(payload);
    }

    return requestOptions;
}

function waitlistAuthPostRequest(
  url: string,
  headers: Headers,
  params: Record<string, string> = {},
  payload?: Payload,
  partnerId?: string
): Promise<any> {
  const partner = partnerId || 'orowealth';
  headers = {
    ...headers,
  };
  
  const updatedHeaders: Headers = {
    ...headers,
    'Content-Type': 'application/json',
    // 'X-partner': partner,
    "X-partner": isMTDomain() ? getXPartner() : partner,
  };

  const queryParam = Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join('&');

  let finalUrl = url;
  if (queryParam) {
    finalUrl += `?${queryParam}`;
  }

  const requestOptions: RequestOptions = {
    method: 'POST',
    headers: updatedHeaders,
    body: JSON.stringify(payload),
    credentials: 'include',
  };

  return fetch(`${process.env.API_BASE_URL}${finalUrl}`, requestOptions)
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse);
}

async function otpAuthPostRequest(url: string, headers: Headers, payload: Payload): Promise<any> {
        const requestOptions = createRequestOptions("POST", headers, payload);
    let response;

    if (
        (url.includes("/register") || url.includes("/login") || url.includes("/updateUserEmail") || url.includes("/userEmailVerify")) &&
        typeof payload?.referrer_source != "undefined" &&
        payload.referrer_source &&
        payload.referrer_source != ""
    ) {
        const type = String(
            payload?.referrer_source,
        ).toUpperCase() as keyof typeof apiBasedSubDomains;
        requestOptions.headers.flag = "referrer-source";
        response = await fetch(`${apiBasedSubDomains[type]}${url}`, requestOptions);
    } else {
        response = await fetch(`${process.env.API_BASE_URL}${url}`, requestOptions);
    }
    return response.json();
}

async function otpAuthGetRequest(url: string, headers: Headers): Promise<any> {
  const requestOptions = createRequestOptions('GET', headers);
  const response = await fetch(`${process.env.API_BASE_URL}${url}`, requestOptions);
  return response.json();
}